
var dlbConsumerRequire, dlbConsumerIds;
__webpack_require__.linkDlb = function(require, ids) {
  dlbConsumerRequire = require;
  dlbConsumerIds = ids;
}

window["__webpack_require_react-dlb/static-1.97/bundle.production.js__"] = window["__webpack_require_react-dlb/bundle.production.js__"] = __webpack_require__;

window["__dlb_react-dlb/static-1.97/bundle.production.js__"] = window["__dlb_react-dlb/bundle.production.js__"] = {
  // create returns an isolated per-consumer require for this DLB.
  create: function(consumerRequire, consumerIds) {
    var cache = {};
    function req(moduleId) {
      if (cache[moduleId] !== undefined) return cache[moduleId].exports;
      var mod = cache[moduleId] = { id: moduleId, loaded: false, exports: {} };
      __webpack_require__.m[moduleId].call(mod.exports, mod, mod.exports, req);
      mod.loaded = true;
      return mod.exports;
    }
    // Inherit the DLB's stateless runtime helpers (m, r, d, n, o, nmd, ...) so DLB
    // modules that reference them keep working. Only the module cache above and the
    // dlbcr below are per-consumer; everything else is shared with the DLB runtime.
    for (var k in __webpack_require__) {
      if (Object.prototype.hasOwnProperty.call(__webpack_require__, k)) {
        req[k] = __webpack_require__[k];
      }
    }
    req.dlbcr = function(id) {
      var otherId = consumerIds[id];
      if (typeof otherId === 'undefined') {
        throw new Error('dlb consumer does not provide module ' + id);
      }
      return consumerRequire(otherId);
    };
    return req;
  }
};

__webpack_require__.dlbcr = function(id) {
  if (!dlbConsumerRequire) {
    throw new Error('dlb consumer not properly linked');
  }
  var otherId = dlbConsumerIds[id];
  if (typeof otherId === 'undefined') {
    throw new Error('dlb consumer does not provide module ' + id);
  }
  return dlbConsumerRequire(otherId);
}
